import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { AERole } from "./AERole";
import { CONTEXT as EmyProjectContext } from "../../app/modules/EmyProjects/helpers/ModuleHelpers";

export const AELink = ({ to, children, className, ...props }) => {
  return (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  );
};

AELink.propTypes = {
  // to : PropTypes.oneOf([
  //   '/',
  //   `/emy_projects`,
  //   `/emy_projects/new`,
  //   `/emy_services`,
  //   `/emy_services/new`,
  //   `/emy_products`,
  //   `/emy_services/new`,
  //   `/teams`, `/teams/new`,
  //   `/contacts`, `/contacts/new`,
  //   `/users`, `/users/new`,
  //   `/locations`, `/locations/new`,
  //
  // ])
};
//checks if user can view the contact
export const canView = (value) => {
  return value && !value.includes("*");
};
export const AEPhone = ({ value }) => {
  if (canView(value)) return <a href={`tel:${value}`}>{value}</a>;

  return <button className="btn-link bg-transparent border-0">{value}</button>;
};

export const AEEmail = ({ value, variant }) => {
  if (canView(value))
    return (
      <a
        href={`mailto:${value}`}
        className={`text-${variant} text-hover-${variant}`}
      >
        {value}
      </a>
    );
  return <button className="btn-link bg-transparent border-0">{value}</button>;
};

export const AEUrl = ({ value }) => {
  const link =
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("www")
      ? value
      : `//${value}`;

  return (
    <a target="_blank" href={link}>
      {value}
    </a>
  );
};

const getClickableLink = (link) => {
  return link.startsWith("http://") || link.startsWith("https://")
    ? link
    : `http://${link}`;
};
